import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { IconButton } from "@mui/material";
import React from "react";

import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import useAdditionalAddressData from "@/hooks/data/use-addictional-address-contact";
import usePopOver from "@/hooks/use-popover";
import IContact, { IAddress } from "@/interfaces/contact.interface";
import { ContactInfoMessages } from "@/messages/contacts/contact-Info.messages";

import { AddressPopover } from "../AddressPopover";

interface Props {
  address: IAddress;
  index: number;
  messages: ContactInfoMessages;
  contact: IContact | null;
}

export function AddressTableRow({ address, index, messages, contact }: Props) {
  const popover = usePopOver<IAddress>();
  const { openPopover, anchorEl, closePopover, isOpen, selected } = popover;

  const additionalAddress = address;
  const addressData = useAdditionalAddressData({ additionalAddress });

  return (
    <>
      <TableRow index={index}>
        <TableCell>{addressData.addressName}</TableCell>
        <TableCell>{addressData.address}</TableCell>
        <TableCell>{addressData.addressNumber}</TableCell>
        <TableCell>{addressData.addressCompl}</TableCell>
        <TableCell>{addressData.addressDistrict}</TableCell>
        <TableCell>{addressData.addressCity}</TableCell>
        <TableCell>{addressData.addressState}</TableCell>
        <TableCell>{addressData.addressStateUf}</TableCell>
        <TableCell>{addressData.formattedZipCode}</TableCell>
        <TableCell>{addressData.addressCountry}</TableCell>
        <TableCell>
          <IconButton onClick={(e) => openPopover(e, address)}>
            <MoreHorizIcon />
          </IconButton>
        </TableCell>
      </TableRow>

      {selected && (
        <AddressPopover
          isOpen={isOpen}
          anchorEl={anchorEl}
          onClose={closePopover}
          messages={messages}
          selected={selected}
          contact={contact}
        />
      )}
    </>
  );
}
